<template>
    <v-container class="commissions-container" fluid>
        <!-- Общий шаблон для всех типов БП -->
        <div
            v-for="(productType, index) in productTypes"
            :key="index"
            class="product-type-section"
            :class="{ 'mt-8': index > 0 }"
        >
            <h3 class="product-type-title mb-4">{{ productType.title }}</h3>
            <v-layout class="companies-row" wrap>
                <v-flex
                    v-for="company in productType.offers"
                    :key="company.id"
                    class="company-card"
                    xs6 sm4 md3 lg2
                >
                    <div class="company-content">
                        <div class="company-header">
                            <img
                                :src="company.image"
                                :alt="company.description"
                                class="company-logo"
                                v-if="company.image"
                            >
                            <div class="company-name">{{ companyName(company.name) }}</div>
                        </div>
                        <div class="commission-field">
                            <div class="commission-value">
                                {{ Number(company.premium * (company.commission_percentage / 100)).toFixed(0)  }} ₽
                            </div>
                            <v-text-field
                                v-if="value.canEdit"
                                :rules="[rules.commission]"
                                validate-on-blur
                                v-model.lazy="company.commission_percentage"
                                suffix="%"
                                outlined
                                dense
                                class="centered-input"
                            ></v-text-field>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
export default {
    props: {
        canEdit: Boolean,
        commissions: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            value: {
                canEdit: false,
                commissions: []
            },
            rules: {
                commission: v => (/^[0-9]+$/.test(v) && v <= 100) || v === '' ? true : 'Ошибка'
            }
        };
    },

    computed: {
        // Группируем компании по типам для рендеринга
        productTypes() {
            return [
                {
                    title: 'Дебетовые карты',
                    offers: this.value.commissions.filter(c => c.type === 'debit')
                },
                {
                    title: 'Кредитные карты',
                    offers: this.value.commissions.filter(c => c.type === 'credit')
                },
                {
                    title: 'МикроКредиты',
                    offers: this.value.commissions.filter(c => c.type === 'microcredit')
                },
                {
                    title: 'Ипотека',
                    offers: this.value.commissions.filter(c => c.type === 'mortgage')
                }
            ].filter(type => type.offers.length > 0); // Показываем только непустые секции
        }
    },

    methods: {
        companyName(fullName) {
            return fullName.split('-')[0].trim();
        }
    },

    created() {
        this.value.canEdit = this.canEdit;
        this.value.commissions = Object.values(this.commissions)
            .filter(item => item.id && item.id !== 'undefined');
    }
}
</script>

<style scoped>
.commissions-container {
    max-width: 100%;
    padding: 20px;
}

.product-type-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.product-type-title {
    color: #2c3e50;
    font-weight: 600;
    font-size: 24px;
}

.companies-row {
    margin: -10px;
    gap: 15px;
    justify-content: flex-start;
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
}

.company-card {
    padding: 10px;
    min-width: 200px;
    max-width: fit-content;
}

.company-content {
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    padding: 15px;
    height: 100%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.company-header {
    margin-bottom: 15px;
    text-align: center;
}

.company-logo {
    max-height: 40px;
    max-width: 100%;
    margin-bottom: 8px;
}

.company-name {
    font-size: 16px;
    font-weight: 500;
    color: #34495e;
    line-height: 1.2;
    word-break: break-word;
}

.commission-field {
    text-align: center;
}

.centered-input >>> .v-input__control {
    justify-content: center;
}

.centered-input >>> input {
    text-align: center;
}

.commission-value {
    font-size: 24px;
    font-weight: 600;
    color: #27ae60;
    padding: 8px 0;
}

@media (max-width: 600px) {
    .company-card {
        flex: 0 0 50%;
        max-width: 50%;
    }

    .company-name {
        font-size: 14px;
    }

    .commission-value {
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/CommissionsBankingProducts.vue